import { api } from 'tools/api-service';
import { AxiosResponse } from 'axios';

export const getHelpBlock = async (): Promise<AxiosResponse<string>> => {
    const response = await api.get(`/helpcentre/help-block`);

    return response;
};
